(function () {
  function getValueFromField(field) {
    const checked = field.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
    const select = field.querySelector('select');
    const textarea = field.querySelector('textarea');
    const input = field.querySelector('input[type="text"], input[type="number"]');

    if (checked) return checked.value;
    if (select) return select.value;
    if (textarea) return textarea.value;
    if (input) return input.value;

    return '';
  }

  function collectTcustomizerProperties() {
    const properties = {};

    document.querySelectorAll('.tcustomizer-field').forEach(function (field) {
      const label = field.querySelector('.tcustomizer-field__heading span');
      if (!label) return;

      const name = label.textContent.replace(':', '').trim();
      const value = getValueFromField(field);

      if (name && value) {
        properties[name] = value;
      }
    });

    document.querySelectorAll('.tcustomizer-data input[name^="properties["]').forEach(function (input) {
      const match = input.name.match(/^properties\[(.+)\]$/);
      if (match && input.value) {
        properties[match[1]] = input.value;
      }
    });

    const summaryTotal = document.querySelector('.js-summary-total');
    if (summaryTotal) {
      const value = summaryTotal.textContent.trim();
      if (value && value !== '(mm)' && value !== 'Total size will appear here') {
        properties['Total screen size'] = value;
      }
    }

    return properties;
  }

  const originalFetch = window.fetch;

  window.fetch = function (url, options) {
    const urlString = typeof url === 'string' ? url : url && url.url ? url.url : '';

    if (urlString.includes('/cart/add') && options && options.body instanceof FormData) {
      const properties = collectTcustomizerProperties();

      Object.keys(properties).forEach(function (key) {
        options.body.append('properties[' + key + ']', properties[key]);
      });
    }

    return originalFetch.apply(this, arguments);
  };
})();